export default __webpack_public_path__ + "media/images/82-2e853b0109883294f45382a273e9de16.jpg";